/** API Nest en servidor EMCALI (prefijo /creg075; el codigo agrega /proyectos). */
export const PROYECTOS_API_REMOTE_BASE =
  "https://numeracioncontratosbk.emcali.com.co/creg075";
